// extracted by mini-css-extract-plugin
var _1 = "JBA_rgdDLV0IfMdTDIsa";
var _2 = "F_DlNVSgYoe21DKUsWQ6";
var _3 = "srGAmk_enMSM5V2xfVro";
var _4 = "J0AS9vqNCyAPGphoVXSA";
var _5 = "J1okO5TTbvH4gJM_YdXg";
export { _1 as "headerClass", _2 as "large", _3 as "sizes", _4 as "small", _5 as "subTitle" }
